import { FC } from 'react';

import LocalDiningIcon from '@mui/icons-material/LocalDining';
import ToolCard from 'components/ToolCard';
import Button from '@mui/material/Button';

const CateringCard: FC = () => (
  <ToolCard
    icon={<LocalDiningIcon fontSize="large" />}
    title="Maitinimas"
    description="Maitinimo pasirinkimų redagavimas"
    action={
      <Button href="catering" startIcon={<LocalDiningIcon />} size="small">
        Redaguoti
      </Button>
    }
  />
);

export default CateringCard;
